export type TileSizeType = 'sm' | 'lg';
export type BadgeType = 'NONE' | 'NEW' | 'LIMITED' | 'OUT_OF_STOCK';
